import { render } from "./registerClient.html?vue&type=template&id=60cf8a16&scoped=true&ts=true&external"
import script from "./RegisterClient.vue?vue&type=script&lang=ts"
export * from "./RegisterClient.vue?vue&type=script&lang=ts"

import "./RegisterClient.vue?vue&type=style&index=0&id=60cf8a16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cf8a16"]])

export default __exports__